async function devtricker_fetch_unread_notifications_count() {
    try {
        const userId = devtricker_getTheLoggedUserId();
        const url = new URL('/wp-admin/admin-ajax.php', window.location.origin);

        url.searchParams.append('action', 'devtricker_notification_has_unread_notifications_action');
        url.searchParams.append('user_id', userId);

        const response = await fetch(url, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const result = await response.json();

        if (result.success) {
            // console.log('Total unread notifications:', result.data.count);
            return result.data;
        } else {
            console.error('Error fetching notifications:', result.data ? result.data.message : 'Unknown error');
            return null;
        }
    } catch (error) {
        console.error('Failed to fetch unread notifications:', error);
        return null;
    }
}

async function devtricker_fetch_unread_notifications(page = 1) {
    const userId = devtricker_getTheLoggedUserId();

    const url = new URL('/wp-admin/admin-ajax.php', window.location.origin);
    url.searchParams.append('action', 'devtricker_fetch_notifications_action');
    url.searchParams.append('page', page);
    url.searchParams.append('user_id', userId);

    try {
        const response = await fetch(url, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const result = await response.json();
        if (result.success) {
            return result.data;
        } else {
            console.error('Error fetching notifications:', result.data ? result.data.message : 'Unknown error');
            return null;
        }
    } catch (error) {
        console.error('Failed to fetch notifications:', error);
        return null;
    }
}

async function devtricker_ajax_mark_notifications_as_read() {
    try {
        const form = new FormData();
        form.append('nonce', await devtricker_process_getDevtrickerNonce());
        form.append('action', 'devtricker_notification_mark_notifications_as_read_action');

        const response = await fetch('/wp-admin/admin-ajax.php', {
            method: 'POST',
            credentials: 'same-origin',
            body: form
        });

        if (response.ok) {
            const result = await response.json();

            if (!result.success) {
                throw new Error(result.data.message || "Failed to mark notifications as read.");
            }

            console.log("Notifications marked as read successfully.");
            return result;
        } else {
            throw new Error("Network response was not ok.");
        }
    } catch (error) {
        console.error("Error marking notifications as read:", error);
        throw error;
    }
}